import BaseType from "../BaseType";

export default class LocalizationGroup extends BaseType {
  Name: string = "";
}
